import { render } from "./addRateCode.vue?vue&type=template&id=ad86ef5a&scoped=true"
import script from "./addRateCode.vue?vue&type=script&lang=js"
export * from "./addRateCode.vue?vue&type=script&lang=js"

import "./addRateCode.vue?vue&type=style&index=0&id=ad86ef5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad86ef5a"]])

export default __exports__